// The once-per-deal review gate, for the v3 flow to show in front of "open the deck". Same copy,
// Slack link and acknowledgement logic as v2 (components/calculator/review-gate.ts +
// ReviewGate.tsx), built on the shared Modal (focus trap, scroll lock, z-index) instead of v2's
// hand-built overlay. It is an acknowledgement, not a disclosure: no backdrop click, no Escape,
// no close button — one deliberate "Got it".
//
// Deliberately NOT rendered by the deck or the /story route: this is an internal warning and must
// never appear on the customer-facing surface. The caller shows it when the SE asks for the deck.
// The Modal portals to <body>, outside `.vc-root`, so it uses Tailwind classes, not brand tokens.

import { Button, Modal } from '../../../../_shared/components';
import {
  ESTIMATE_BODY,
  GATE_ACK,
  GATE_BODY,
  GATE_REQUEST,
  GATE_TITLE,
  REVIEW_SLACK_CHANNEL,
  REVIEW_SLACK_URL,
} from '../../calculator/review-gate';

interface ReviewGateDialogProps {
  open: boolean;
  onAck: () => void;
}

export function ReviewGateDialog({ open, onAck }: ReviewGateDialogProps) {
  return (
    <Modal
      open={open}
      title={GATE_TITLE}
      onClose={onAck}
      disableBackdropClose
      disableEscClose
      hideCloseButton
      footer={
        <Button variant="primary" onClick={onAck} autoFocus>
          {GATE_ACK}
        </Button>
      }
    >
      <div className="flex flex-col gap-3 text-sm leading-relaxed">
        <p>{GATE_BODY}</p>
        <p>
          {GATE_REQUEST}{' '}
          <a
            href={REVIEW_SLACK_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="font-medium underline underline-offset-2"
          >
            {REVIEW_SLACK_CHANNEL}
          </a>
          .
        </p>
        <p className="text-xs opacity-70">{ESTIMATE_BODY}</p>
      </div>
    </Modal>
  );
}
